import { render } from "./FormDestino.vue?vue&type=template&id=2f80225f"
import script from "./FormDestino.vue?vue&type=script&lang=js"
export * from "./FormDestino.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__